/* eslint-disable prettier/prettier */
import React from 'react';
import styles from '../../../styles/components/pageComponents/dashboard/AdminActionItems.module.css';

export interface AdminActionItemCardProps
	extends React.HTMLAttributes<HTMLDivElement> {
	type: string; // Type for styling
	icon: React.ReactNode;
	// value: string;
	value: string | number;
	title: string;
	progressPercent?: number;
	className?: string; // Optional custom class for the card
}

const AdminActionItemCard: React.FC<AdminActionItemCardProps> = ({
	type,
	icon,
	value,
	title,
	className,
	...rest
}) => {
	return (
		// <div className={`${styles.card} ${className || ''}`} {...rest}>
		//     <div className={styles.leftSection}>
		//         <div className={`${styles.iconContainer} ${styles[type]}`}>
		//             {icon}
		//         </div>

		//         <span className={styles.title}>{title}</span>
		//     </div>

		//     <span className={styles.value}>{value}</span>
		// </div>
		<div className={`${styles.card} ${className || ''}`} {...rest}>
			{/* 🔥 Top Row */}
			<div className={styles.topRow}>
				<div className={`${styles.iconContainer} ${styles[type]}`}>
					{icon}
				</div>

				<span className={styles.value}>{value}</span>
			</div>

			{/* 🔥 Bottom Row */}
			<span className={styles.title}>{title}</span>
		</div>
	);
};

export default AdminActionItemCard;
